import React from 'react';
import { useTranslation } from 'react-i18next';
import {IconDocumentPassport, IconPhotoTake} from '../../../../components/buttons/IconButtons';
import { useParams } from 'react-router-dom';
import {FILE_TYPE_MODEL} from '../Visitor/Model/Model';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const PassportCardVerification = ({ guardFlowId }) => {
    const { type } = useParams();
    const { t } = useTranslation();

    const PassportVerification = () => {
        return (
            <>
                <div className="row">
                    <div className="col-12 d-flex flex-column justify-content-center align-items-center">
                        <p className="fs-24-to-18 ibl-font-w-600 font-color-general-950 text-center">{t("passport_verification")}</p>
                        { guardFlowId ?
                            <p className="fs-20-to-14 ibl-font-w-400 font-color-general-950 text-center">{t("take_a_clear_photo_of_the_passport_information_page")}</p>
                            :
                            <>
                                <p className="d-none d-md-block fs-20-to-14 ibl-font-w-400 font-color-general-950 text-center">{t("take_a_clear_photo_of_the_passport_information_page")}</p>
                                <p className="d-block d-md-none fs-20-to-14 ibl-font-w-400 font-color-general-950 text-center">{t("take_a_photo_of_the_information_page_of_your_passport")}</p> {/*mobile*/}
                            </>
                        }
                    </div>
                </div>

                <div className="d-flex justify-content-center align-items-center pt-2">
                    <div className="icon-verification-card-passport-container">
                        <IconDocumentPassport className={"h-100 w-100"} />
                    </div>
                </div>

                <div className="d-none d-md-block p-0 m-0">
                    <div className="d-flex justify-content-center align-items-center gap-8px">
                        <IconPhotoTake />
                        <p className="ibl-ientry-p ibl-font-w-600 font-color-general-950">{t("photo_tips")}</p>
                    </div>
                </div>

                <div className="d-none d-md-block">
                    <p className="fs-14-to-13 ibl-font-w-400 font-color-general-950 text-center">
                        {`• ${t("open_the_passport_to_the_photo_page_and_lay_it_flat")}`}<br />
                        {`• ${t("ensure_all_information_is_clear_and_in_focus")}`}<br />
                        {`• ${t("avoid_glare_shadows_or_blurriness")}`}<br />
                        {`• ${t("no_fingers_objects_or_covers_on_any_part_of_the_page")}`}
                    </p>
                </div>
            </>
        )
    }

    const CardVerification = () => {
        return (
            <>
                <div className="row">
                    <div className="col-12 d-flex flex-column justify-content-center align-items-center">
                        <p className="fs-24-to-18 ibl-font-w-600 font-color-general-950 text-center">{t("id_card_verification")}</p>
                        {guardFlowId ?
                                <p className="fs-20-to-14 ibl-font-w-400 font-color-general-950 text-center">{t("take_clear_photos_of_both_front_and_back_of_id")}</p>
                            :
                            <>
                                <p className="d-none d-md-block fs-20-to-14 ibl-font-w-400 font-color-general-950 text-center">{t("take_clear_photos_of_both_the_front_and_back_of_your_id")}</p>
                                <p className="d-block d-md-none fs-20-to-14 ibl-font-w-400 font-color-general-950 text-center">{t("take_photos_of_the_front_and_back_of_your_document")}</p> {/*mobile*/}
                            </>
                        }


                    </div>
                </div>
                <div className="h-180px">
                    <IconDocumentPassport className={"h-100 w-100"} />
                </div>

                <div className="d-none d-md-block p-0 m-0">
                    <div className="d-block d-md-none d-flex justify-content-center align-items-center gap-8px">
                        <IconPhotoTake />
                        <p className="ibl-ientry-p ibl-font-w-600 font-color-general-950">{t("photo_tips")}</p>
                    </div>
                </div>

                <div className="d-none d-md-block">
                    <p className="fs-14-to-13 ibl-font-w-400 font-color-general-950 text-center">
                        {`• ${t("place_the_id_on_a_flat_well_lit_surface")}`}<br />
                        {`• ${t("ensure_all_information_is_clear_and_in_focus")}`}<br />
                        {`• ${t("avoid_glare_shadows_or_blurriness")}`}<br />
                        {`• ${t("don_t_cover_the_id_with_fingers_or_objects")}`}
                    </p>
                </div>
            </>
        )
    }

    return (
        <>
            { type == FILE_TYPE_MODEL.INE.id ? <CardVerification/> : <PassportVerification/> }
        </>
    )

}

export default PassportCardVerification
